import {PermissionsList} from '../../models/Permissions';

export const checkPermissionAndSetState = (
    permissions: any,
    permissionName: string,
    setter: React.Dispatch<React.SetStateAction<boolean>>
) => {
    let hasPermissionValue=hasPermission(permissions, permissionName);
    setter(hasPermissionValue);
    return hasPermissionValue;
};

export const hasPermission = (permissionsData: string[], permission: string): boolean => {
    return permissionsData?.indexOf(permission) >= 0;
};

export const hasAR1Role = (permissionsData: string[]): boolean => {
  return (
    (permissionsData ?? []).indexOf(PermissionsList.workorder_review_triage_repair) >= 0 &&
    (permissionsData ?? []).indexOf(PermissionsList.workorder_no_triage_forheatingandhotwaterrepairs) >= 0 &&
    (permissionsData ?? []).indexOf(PermissionsList.workorder_override_duplicate_repairs) >= 0 &&
    (permissionsData ?? []).indexOf(PermissionsList.workorder_choose_priority_of_repair) >= 0
  );
};

export const hasAdminRole = (permissionsData: string[]): boolean => {
  return (
    (permissionsData ?? []).indexOf(PermissionsList.workorder_review_triage_repair) >= 0
  );
}; 